import React from 'react'
import AnalysisContainer from 'components/wrapper/AnalysisContainer'
import { getRequiredAnalysis, postRequiredAnalysis } from 'api/urls'
import { useHistory } from 'react-router'
import { getQueryParams } from 'utils/Utils'

const ema_analysis = {

    estimated_cagr_in_eps: {
        lable: <span>EPS CAGR %</span>,
        placeholder: 'Ex: 100',
        col: 6,
    },
    estimated_pe_last_year: {
        lable: <span>Exit P/E</span>,
        placeholder: 'Ex: 12',
        col: 6,
    },
    discount_rate: {
        lable: <span>Discount %</span>,
        placeholder: 'Ex: 12',
        col: 6,
    },
    margin_of_safety: {
        lable: <span>Margin of safety %</span>,
        placeholder: 'Ex: 80',
        col: 6,
    },
    ttm_eps: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', textTransform: 'capitalize',color:'black' },
        lable: <span>TTM EPS</span>,
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
    current_pe: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto', textTransform: 'capitalize',color:'black' },
        lable: <span>Current PE</span>,
        placeholder: '0',
        readOnly: true,
        col: 6,
    },
    estimated_eps_last_year: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: <span>Estimated EPS after<br />10 yrs (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    }
    ,
    estimated_stock_price_last_year: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: <span>Estimated Stock Price<br />after 10 yrs (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    },
    Present_value_of_stock: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: <span>Present stock value (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    },
    fair_value: {
        style: { border: 'none', background: 'none', fontWeight: '600', cursor: 'auto',color:'black',textTransform: 'capitalize' },
        lable: <span>Fair value (Rs.)</span>,
        placeholder: '0',
        ignore: true,
        readOnly: true,
        col: 6,
    }
}

const EMAAnalysis = (props) => {
    const history = useHistory()
    const querryParams = getQueryParams(history.location.search)
    return (
        <div  {...props}>
            <AnalysisContainer
                postUrl={postRequiredAnalysis('/earning_multiple_analysis/')}
                url={getRequiredAnalysis('ema', querryParams.company__symbol)}
                title='Earnings Multiple (EPS)'
                cardTextStart='Projects EPS 10 years out, applies an exit P/E, discounts back.'
                cardTextEnd=''
                analysis={ema_analysis}
                inputType='number'
            />
        </div>
    )
}

export default (EMAAnalysis)